export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/aea862695be0-tooliconcalendar.jpg',
  },
  title: 'On what date did you open the account?',
  noteTop: [
    "Don't worry if you can't remember the exact date. Just be as accurate as possible. This can help the bank locate your records.",
  ],
}
